import type React from 'react';

import type { HNVelgBehandlingsstedFrontend } from '../../types/Resources';

import { useResources } from '../../resources';
import { HN_VELG_BEHANDLINGSSTED_FRONTEND } from '../../utils/resources-project';
import PageContainer from '../page-container';

interface Props {
  pageClass: string;
  breadcrumbResourceId: keyof HNVelgBehandlingsstedFrontend;
  breadcrumbUrl: string;
  children: React.ReactNode;
}

const PageContainerMedBrodsmule: React.FunctionComponent<Props> = ({
  pageClass,
  breadcrumbResourceId: resourceId,
  breadcrumbUrl,
  children,
}) => {
  const resources = useResources<HNVelgBehandlingsstedFrontend>(HN_VELG_BEHANDLINGSSTED_FRONTEND);

  if (!resources) {
    return null;
  }

  const breadcrumbName = resources[resourceId];

  return (
    <PageContainer pageClass={pageClass} breadcrumbLink={{ name: breadcrumbName, url: breadcrumbUrl, renderAsRouterLink: true }}>
      {children}
    </PageContainer>
  );
};

export default PageContainerMedBrodsmule;
